import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import qs from 'qs';
import classNames from 'classnames';
import FormTable from './formTable/FormTable';
import RaceRecords from './raceRecords/RaceRecords';
import transformData from './transformData';
import { raceRecordsType, formType } from './dataPropTypes';

class Form extends Component {
    constructor(props) {
        super(props);

        this.fetchMyRating = this.fetchMyRating.bind(this);
        this.onFilterClick = this.onFilterClick.bind(this);

        this.state = {
            loading: false,
            myRatingFetched: false,
            myRatingData: null,
            selectedFilter: null,
            ...transformData(props.data),
        };
    }


    componentWillMount() {
        const { params: { mr } } = this.props;
        if (mr.isShown) {
            this.fetchMyRating();
        }
    }

    componentDidUpdate() {
        const { params: { mr } } = this.props;
        if (mr.isShown && !this.state.loading && !this.state.myRatingFetched) {
            this.fetchMyRating();
        }
    }

    onFilterClick({ currentTarget: { value: nextFilter } }) {
        if (!this.props.hasAccess) {
            return;
        }
        this.setState(prevState => ({
            selectedFilter: prevState.selectedFilter === nextFilter ? null : nextFilter,
        }));
    }

    fetchMyRating() {
        this.setState({ loading: true });
        const { form: formData } = this.state;
        const { params: { id: horseUid } } = this.props;
        const racesIds = formData.map(entry => entry.raceInstanceUid);

        axios
            .post(`horse/form/ugc/${horseUid}`,
                qs.stringify({ params: racesIds }))
            .then(({ data: { ratings } }) => this.setState({
                loading: false,
                myRatingFetched: true,
                myRatingData: ratings || [],
            }))
            .catch(() => this.setState({ loading: false, myRatingFetched: true }));
    }

    render() {
        const {
            selectedFilter, records,
            figures, form, hasSpecial,
            myRatingData, loading,
        } = this.state;
        const {
            params, hasAccess,
        } = this.props;

        const data = {
            loading,
            form,
            myRatings: myRatingData,
            raceRecords: records,
        };

        return (
            <section>
                <RaceRecords
                    data={data}
                    figures={figures}
                    onFilterClick={this.onFilterClick}
                    selectedFilter={selectedFilter}
                    params={params}
                    hasAccess={hasAccess}
                />
                <FormTable
                    data={data}
                    hasSpecial={hasSpecial}
                    selectedFilter={selectedFilter}
                    params={params}
                    hasAccess={hasAccess}
                />
                <div
                    className={classNames(
                    'pp-bottomText',
                    !hasAccess && 'pp-bottomText--without-access'
                )}
                >
                    <span>
                        Details of horses trained outside GB and Ireland
                        or born prior to 1986 may be incomplete.
                    </span>
                    <span>&nbsp;OR Rating is the latest published.<br /></span>
                    <span>
                        GB PTP results are displayed when
                        a horse is declared to run under rules.
                    </span>
                </div>
            </section>
        );
    }
}

Form.propTypes = {
    data: PropTypes.shape({
        raceRecords: raceRecordsType,
        form: formType,
        profile: PropTypes.shape({
            weatherbysUid: PropTypes.string,
        }),
    }),
    params: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        subTab: PropTypes.string,
    }),
    hasAccess: PropTypes.bool,
};

Form.displayName = 'Form';

export default Form;



// WEBPACK FOOTER //
// ./src/js/horse/form/Form.jsx